import {Component, OnInit} from '@angular/core';

@Component({
  selector: 'arm-form-title',
  templateUrl: './arm-form-title.component.html',
  styleUrls: ['./arm-form-title.component.scss']
})
export class ArmFormTitleComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
